export default "__VITE_ASSET__d4459504__"